/* Paco's tracking-only referral. No commission or payment is calculated. */
(function () {
  var params = new URLSearchParams(window.location.search);
  var partner = params.get('sca_ref') === '12575179.fn1BXXQmL60SM0Y2' || params.get('ref') === 'paco' || params.get('utm_source') === 'paco' ? 'Paco' : '';
  try {
    if (partner) sessionStorage.setItem('gd_referral', partner);
    else if (sessionStorage.getItem('gd_referral') === 'Paco') partner = 'Paco';
  } catch (error) { /* Direct referral links still work when storage is unavailable. */ }
  document.querySelectorAll('[data-gd-referral]').forEach(function (input) {
    if (partner) input.value = partner;
    input.disabled = !input.value;
  });
})();
